// react
import { React } from 'react';

// mui
import { ListItem, ListItemText, ListItemButton, Typography } from '@mui/material';

// components
import { def } from '@goldblack/shared';

function FilterOptionItem(props) {
    return (
        <ListItem disablePadding>
            <ListItemButton
                selected={props.selected}
                onClick={props.onClick}
                sx={{
                    m: 0,
                    backgroundColor: props.filterOption.status === def.FilterStatus.INACTIVE ? 'action.disabled' : '',
                }}>
                <ListItemText
                    sx={{ ml: 1 }}
                    primary={
                        <Typography variant='body1' color='primary.main'>
                            {props.filterOption.name}
                        </Typography>
                    }
                />
            </ListItemButton>
        </ListItem>
    );
}

export { FilterOptionItem };
